// fullscreenBus — App-weiter Fullscreen-Mode für die Karte.
//
// Wave 14cb (User-Wunsch):
//   "ich brauche ein vollbild button ähnlich wie bei youtube/netflix, wenn
//    ich den drücke, dann wird nur noch die karte angezegit, sonst nichts.
//    [...] die 4 buttons rechts (2 oben und das plus und minus) bleiben
//    natürlich auf der karte. aber sonst geht das menü weg unten und beim
//    RIDE modus auch das höhenprofil. so habe ich maximal viel karte im
//    blick"
//
// Subscriber:
//   - App.tsx           → versteckt <TabBar> wenn fullscreen
//   - MapPage.tsx       → versteckt <BottomBar>, Trail-Detail-Sheet,
//                         Ride-Höhenprofil-Sheet
//   - FullscreenToggle  → bleibt sichtbar, wechselt Icon expand ↔ collapse
//
// Persistenz: KEINE (ULTRA-Hotfix). Fullscreen ist ab jetzt ein reiner
// SESSION-Zustand — jeder App-Start beginnt mit fullscreen=false (UI sichtbar).
//
// Warum die frühere localStorage-Persistenz raus ist: ein User hatte im Rennen
// versehentlich Fullscreen aktiviert (TabBar UNTEN + Compass RECHTS weg, nur
// Zoom/POI/Exit-Icon sichtbar) und den Exit-Button übersehen. Da der Zustand
// in localStorage lag, blieb er bei JEDEM Neuladen aktiv — der User saß fest,
// ohne Weg aus dem Map-Screen. Als Session-Zustand befreit ein Reload/Neustart
// den User immer. Der Fullscreen-Toggle auf der Karte funktioniert innerhalb
// der laufenden Session unverändert weiter.

const KEY = 'adt_fullscreen';

type Listener = (snapshot: boolean) => void;

class FullscreenBus {
  private current = false;
  private readonly listeners = new Set<Listener>();
  private hydrated = false;

  /** ULTRA-Hotfix: KEINE Hydration aus localStorage mehr. Fullscreen startet
   *  immer als false. Einmalig räumen wir einen evtl. noch persistierten
   *  Alt-Wert weg, damit „eingesperrte" User (die den Key vor diesem Fix
   *  gesetzt hatten) beim ersten Öffnen wieder eine sichtbare UI (TabBar +
   *  Compass) bekommen. */
  private hydrate() {
    if (this.hydrated) return;
    this.hydrated = true;
    this.current = false;
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* SSR / Privacy-Mode → egal, current ist ohnehin false */
    }
  }

  get(): boolean {
    this.hydrate();
    return this.current;
  }

  set(next: boolean) {
    this.hydrate();
    if (next === this.current) return;
    this.current = next;
    // Kein localStorage-Write mehr — Fullscreen ist Session-only (s. o.).
    for (const l of this.listeners) l(next);
  }

  toggle() {
    this.set(!this.get());
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const fullscreenBus = new FullscreenBus();
